import React, { useEffect, useState } from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { AnimatePresence, motion } from "framer-motion";
import * as Toast from "@radix-ui/react-toast";
import { authError } from "../../utils/errors/authError";
import { AiOutlineClose } from "react-icons/ai";
import { HiLightningBolt } from "react-icons/hi";
import { FiCheck } from "react-icons/fi";
import { IoArrowBack } from "react-icons/io5";
import ModalPhone from "./modalphone";
import * as Tooltip from "@radix-ui/react-tooltip";
import { VscInfo } from "react-icons/vsc";
import { getAuth } from "firebase/auth";
import { getActivePropertiesCount } from "../../utils/manager/getActivePropertyCount";

function UpgradeModal({
  open,
  setOpen,
  listerData,
  fireConfetti,
  verifyTrans,
}) {
  const [openToast, setOpenToast] = useState(false);
  const [error, setError] = useState(null);
  const [phoneCheckout, setPhoneCheckout] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState("");
  const [tooltip1, setTooltip1] = useState(false);
  const [tooltipComingAnalytics, setTooltipComingAnalytics] = useState(false);
  const [tooltipComingMessage, setTooltipComingMessage] = useState(false);
  const auth = getAuth();
  const user = auth.currentUser;
  const [activeProps, setActiveProps] = useState(null);

  useEffect(() => {
    if (open && user) {
      getActivePropertiesCount(user.uid).then((count) => {
        setActiveProps(count);
      });
    }
  }, [user, open]);

  return (
    <>
      <Dialog.Root
        open={open}
        onOpenChange={(open) => {
          setOpen(open);
        }}
      >
        <Dialog.Trigger asChild></Dialog.Trigger>
        <AnimatePresence>
          {open ? (
            <Dialog.Portal forceMount>
              <Dialog.Overlay forceMount>
                <motion.div
                  key="overlay"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 0.5 }}
                  exit={{
                    opacity: 0,
                    transition: {
                      duration: 0.05,
                    },
                  }}
                  className=" fixed inset-0  z-20 h-screen bg-black opacity-50"
                ></motion.div>
              </Dialog.Overlay>

              <Dialog.Content
                forceMount
                onOpenAutoFocus={(e) => {
                  e.preventDefault();
                }}
              >
                <motion.div
                  key="modal"
                  initial={{ scale: 0.7 }}
                  animate={{ scale: 1 }}
                  transition={{
                    type: "spring",
                    stiffness: 400,
                    damping: 40,
                    duration: 0.2,
                  }}
                  exit={{
                    opacity: 0,
                    scale: 0.8,
                    transition: {
                      duration: 0.05,
                    },
                  }}
                  className={
                    " absolute left-0 top-0 z-20 flex h-screen w-[100vw] flex-col overflow-y-auto  rounded-md bg-white px-2 py-12 lg:left-[15vw] lg:top-[10vh] lg:h-[80vh] lg:w-[70vw] lg:overflow-auto lg:px-10" +
                    (phoneCheckout ? " space-y-8" : " space-y-16")
                  }
                >
                  <Dialog.Title className=" flex flex-row  items-center justify-between text-center text-black">
                    <span>
                      {phoneCheckout ? (
                        <span className=" flex h-8 w-8 flex-shrink-0  cursor-pointer items-center justify-center rounded-full bg-gray-100 text-sm hover:bg-gray-200">
                          <IoArrowBack
                            onClick={() => {
                              setPhoneCheckout(false);
                            }}
                            className=" h-5 w-5 text-gray-500"
                          />
                        </span>
                      ) : null}
                    </span>
                    <div className=" flex flex-col space-y-1">
                      <span className="  select-none text-2xl font-semibold lg:text-3xl">
                        Move fast and add more properties
                      </span>
                      <span className=" select-none px-10 text-center text-sm lg:px-2">
                        Attract more prospective buyers and renters looking for
                        their next home
                      </span>
                    </div>
                    <Dialog.Close asChild>
                      <span className=" flex h-6 w-6 flex-shrink-0  cursor-pointer items-center justify-center rounded-full text-sm hover:bg-gray-200">
                        <AiOutlineClose className=" h-4 w-4 text-gray-500" />
                      </span>
                    </Dialog.Close>
                  </Dialog.Title>

                  {!phoneCheckout ? (
                    <form
                      onSubmit={(e) => {
                        e.preventDefault();
                      }}
                      className=" "
                    >
                      <div className=" relative flex flex-row rounded-md border border-gray-300 lg:h-88">
                        <div className="flex w-1/3 flex-col space-y-4 rounded-l-md bg-white py-5 pl-5 pr-2 lg:px-5">
                          <div className="flex flex-col space-y-1">
                            <div className=" flex flex-row space-x-1">
                              <span className=" text-lg font-medium">Flex</span>
                            </div>

                            <span className=" text-sm text-gray-700">
                              A new home for homes
                            </span>
                          </div>
                          <div className=" flex flex-col space-y-2 text-sm">
                            <div className="flex flex-row items-center space-x-3">
                              <FiCheck className="h-4 w-4 flex-shrink-0 text-ula-primary" />
                              <div className=" flex flex-row items-center space-x-2">
                                <span className="text-gray-700">
                                  30 Active properties
                                </span>
                                <Tooltip.Provider delayDuration={500}>
                                  <Tooltip.Root
                                    open={tooltip1}
                                    onOpenChange={(op) => {
                                      if (!op) {
                                        setTooltip1(false);
                                      }
                                    }}
                                  >
                                    <Tooltip.Trigger
                                      onClick={() => {
                                        setTooltip1(!tooltip1);
                                      }}
                                    >
                                      <VscInfo className=" cursor-pointer text-gray-700" />
                                    </Tooltip.Trigger>
                                    <Tooltip.Portal>
                                      <Tooltip.Content className=" z-20 w-56 rounded-md border  border-gray-800 bg-gray-800 px-4  py-3 leading-4">
                                        <span className=" text-sm text-gray-100">
                                          Active properties are those visible to
                                          buyers and renters.
                                        </span>
                                        <Tooltip.Arrow className="  fill-gray-800" />
                                      </Tooltip.Content>
                                    </Tooltip.Portal>
                                  </Tooltip.Root>
                                </Tooltip.Provider>
                              </div>
                            </div>
                            <div className="flex flex-row items-center space-x-3 ">
                              <FiCheck className="h-4 w-4 flex-shrink-0 text-ula-primary" />
                              <span className="text-gray-700">
                                2 team members
                              </span>
                            </div>
                            <div className="flex flex-row items-center space-x-3">
                              <FiCheck className="h-4 w-4 flex-shrink-0 text-ula-primary" />
                              <div className="flex flex-row items-center space-x-2">
                                <span className=" text-gray-700">
                                  Property Analytics and Insights
                                </span>

                                {/* <Tooltip.Provider delayDuration={500}>
                                  <Tooltip.Root
                                    open={tooltipComingAnalytics}
                                    onOpenChange={(op) => {
                                      if (!op) {
                                        setTooltipComingAnalytics(false);
                                      }
                                    }}
                                  >
                                    <Tooltip.Trigger
                                      onClick={() => {
                                        setTooltipComingAnalytics(!tooltip1);
                                      }}
                                    >
                                      <VscInfo className=" text-gray-700 cursor-pointer" />
                                    </Tooltip.Trigger>
                                    <Tooltip.Portal>
                                      <Tooltip.Content className=" py-3 px-4 z-20 w-56  leading-4 bg-gray-800 border  border-gray-800 rounded-md">
                                        <span className=" text-gray-100 text-sm">
                                          Property Analytics is coming soon
                                        </span>
                                        <Tooltip.Arrow className="  fill-gray-800" />
                                      </Tooltip.Content>
                                    </Tooltip.Portal>
                                  </Tooltip.Root>
                                </Tooltip.Provider> */}
                              </div>
                            </div>

                            <div className="flex flex-row items-center space-x-3">
                              <FiCheck className="h-4 w-4 flex-shrink-0 text-ula-primary" />
                              <div className=" flex flex-row items-start">
                                <span className="text-gray-700">
                                  One to one message with buyers and renters
                                </span>
                                {/* <Tooltip.Provider delayDuration={500}>
                                  <Tooltip.Root
                                    open={tooltipComingMessage}
                                    onOpenChange={(op) => {
                                      if (!op) {
                                        setTooltipComingMessage(false);
                                      }
                                    }}
                                  >
                                    <Tooltip.Trigger
                                      onClick={() => {
                                        setTooltipComingMessage(!tooltip1);
                                      }}
                                    >
                                      <VscInfo className=" mt-1 text-gray-700 cursor-pointer" />
                                    </Tooltip.Trigger>
                                    <Tooltip.Portal>
                                      <Tooltip.Content className=" py-3 px-4 z-20 w-56  leading-4 bg-gray-800 border  border-gray-800 rounded-md">
                                        <span className=" text-gray-100 text-sm">
                                          Messaging with buyers and renters is coming soon
                                        </span>
                                        <Tooltip.Arrow className="  fill-gray-800" />
                                      </Tooltip.Content>
                                    </Tooltip.Portal>
                                  </Tooltip.Root>
                                </Tooltip.Provider> */}
                              </div>
                            </div>
                            {/* <div className='flex flex-row items-center space-x-3 opacity-0'>
                                <FiCheck className='h-4 w-4 text-ula-primary flex-shrink-0' />
                                <span className='text-gray-700'>Lister Screening</span>
                            </div> */}
                          </div>

                          {/* <span className=" text-base font-medium">Free</span> */}
                          {listerData.currentPlan?.plan === "FREE" ? (
                            <div className=" flex flex-col items-center pt-10">
                              <span className=" font-medium lg:text-lg">
                                <span className=" font-medium">Kshs 0 </span>
                                <span className=" text-base">
                                  + Kshs 300 / lead
                                </span>
                              </span>
                              <span className=" py-0 text-center text-base font-medium text-gray-600">
                                Your current plan
                              </span>
                            </div>
                          ) : (
                            <span className=" py-3 text-center text-base font-medium text-gray-800">
                              Inactive
                            </span>
                          )}
                        </div>
                        <div className=" relative flex w-1/3 flex-col">
                          {listerData.currentPlan?.plan === "FREE" ||
                          (listerData.currentPlan?.plan === "PREMIUM" &&
                            activeProps < 50) ? (
                            <div className="absolute -mt-10 flex h-10 w-full flex-row items-center justify-center space-x-2 rounded-t-md bg-blue-100">
                              <HiLightningBolt />
                              <span className=" text-xs font-medium">
                                Most popular
                              </span>
                            </div>
                          ) : null}
                          <div className="flex h-full w-full flex-col space-y-4 rounded-b-md border border-blue-100 bg-white py-5 pl-5 pr-2 lg:px-5">
                            <div className="flex flex-col space-y-1">
                              <span className=" text-lg font-medium">
                                Premium
                              </span>
                              <span className=" text-sm text-gray-700">
                                More properties, more reach
                              </span>
                            </div>
                            <div className=" flex flex-col space-y-2 text-sm">
                              <span className=" text-gray-700">
                                Everything in{" "}
                                <span className=" font-semibold">Flex</span>,
                                plus
                              </span>
                              <div className="flex flex-row items-center space-x-3">
                                <FiCheck className="h-4 w-4 flex-shrink-0 text-ula-primary" />
                                <div className=" flex flex-row items-center space-x-2">
                                  <span className="text-gray-700">
                                    80 Active properties
                                  </span>
                                </div>
                              </div>
                              <div className="flex flex-row items-center space-x-3 ">
                                <FiCheck className="h-4 w-4 flex-shrink-0 text-ula-primary" />
                                <span className="text-gray-700">
                                  5 team members
                                </span>
                              </div>
                              <div className="flex flex-row items-center space-x-3 ">
                                <FiCheck className="h-4 w-4 flex-shrink-0 text-ula-primary" />
                                <span className="text-gray-700">
                                  Leads sent to Whatsapp Inbox
                                </span>
                              </div>
                              <div className="flex flex-row items-center space-x-3">
                                <FiCheck className="h-4 w-4 text-ula-primary" />
                                <span className="text-gray-700">
                                  Dedicated support
                                </span>
                              </div>

                              <div className="invisible flex flex-row items-center space-x-3">
                                <FiCheck className="h-4 w-4 text-ula-primary" />
                                <span className="text-gray-700">
                                  Lister Screening
                                </span>
                              </div>
                            </div>

                            <span className=" text-base font-medium">
                              Kshs 9,500 / month
                            </span>
                            {listerData.currentPlan?.plan != "FREE" ? (
                              <>
                                {listerData.currentPlan?.plan === "BUSINESS" ? (
                                  <span className=" py-3 text-center text-base font-medium text-gray-800">
                                    Inactive
                                  </span>
                                ) : (
                                  <span className=" py-3 text-center text-base font-medium text-gray-600">
                                    Your current plan
                                  </span>
                                )}
                              </>
                            ) : (
                              <button
                                onClick={() => {
                                  setSelectedPlan("PREMIUM");
                                  setPhoneCheckout(true);
                                }}
                                className=" w-full  rounded-md bg-ula-primary py-3  text-sm text-white lg:w-full"
                              >
                                Upgrade now
                              </button>
                            )}
                          </div>
                        </div>
                        <div className="relative flex h-full w-1/3 flex-col space-y-4 rounded-r-md bg-white py-5 pr-2 lg:px-0 lg:pl-0">
                          {listerData.currentPlan?.plan === "PREMIUM" &&
                          activeProps > 90 ? (
                            <div className="absolute -mt-[3.7rem] flex h-10 w-full flex-row items-center justify-center space-x-2 rounded-t-md bg-blue-100">
                              <HiLightningBolt />
                              <span className=" text-xs font-medium">
                                Recommended
                              </span>
                            </div>
                          ) : null}
                          <div className="flex flex-col space-y-1 pl-2 lg:px-5 lg:pl-5">
                            <span className=" text-lg font-medium">
                              Business
                            </span>
                            <span className=" text-sm text-gray-700">
                              An entire marketplace for properties
                            </span>
                          </div>
                          <div className=" flex flex-col space-y-2 pl-2 text-sm lg:px-5  lg:pl-5">
                            <span className=" text-gray-700">
                              Everything in{" "}
                              <span className=" font-semibold">Premium</span>,
                              plus
                            </span>
                            <div className="flex flex-row items-center space-x-3">
                              <FiCheck className="h-4 w-4 flex-shrink-0 text-ula-primary" />
                              <div className=" flex flex-row flex-wrap space-x-1 text-gray-700">
                                <span className="flex flex-shrink-0 flex-row text-gray-700">
                                  150 Active
                                </span>
                                {/* <span className="hidden lg:flex"> Active </span> */}
                                <span className="">properties </span>
                              </div>
                            </div>
                            <div className="flex flex-row items-center space-x-3 ">
                              <FiCheck className="h-4 w-4 flex-shrink-0 text-ula-primary" />
                              <span className="text-gray-700">
                                Advanced search
                              </span>
                            </div>
                            {/* <div className="flex flex-row items-center space-x-3 ">
                              <FiCheck className="h-4 w-4 flex-shrink-0 text-ula-primary" />
                              <span className="text-gray-700">
                                Lead export to own CRM
                              </span>
                            </div> */}
                            <div className="flex flex-row items-center space-x-3 ">
                              <FiCheck className="h-4 w-4 flex-shrink-0 text-ula-primary" />
                              <span className="text-gray-700">
                                Unlimited team members
                              </span>
                            </div>

                            <div className="invisible flex flex-row items-center space-x-3">
                              <FiCheck className="h-4 w-4 flex-shrink-0 text-ula-primary" />
                              <span className=" text-gray-700">
                                Property Analytics
                              </span>
                            </div>
                            <div className="invisible flex flex-row items-center space-x-3">
                              <FiCheck className="h-4 w-4 text-ula-primary" />
                              <span className="text-gray-700">
                                Lister Screening
                              </span>
                            </div>
                          </div>

                          <span className=" pl-2 text-base font-medium lg:px-5  lg:pl-5">
                            Kshs 21,500 / month
                          </span>

                          {listerData.currentPlan?.plan != "FREE" ? (
                            <>
                              {listerData.currentPlan?.plan === "PREMIUM" ? (
                                <div className=" px-2 lg:pl-5 lg:pr-2">
                                  {activeProps > 65 ? (
                                    <button
                                      onClick={() => {
                                        setSelectedPlan("BUSINESS");
                                        setPhoneCheckout(true);
                                      }}
                                      className=" w-full  rounded-md bg-ula-primary px-2  py-3 text-sm text-white lg:w-full lg:px-0"
                                    >
                                      Upgrade now
                                    </button>
                                  ) : (
                                    <span className=" px-2 py-3 text-center text-base font-medium text-gray-800 lg:px-5">
                                      Inactive
                                    </span>
                                  )}
                                </div>
                              ) : (
                                <span className=" px-2 py-3 text-center text-base font-medium text-gray-600 lg:px-5">
                                  Your current plan
                                </span>
                              )}
                            </>
                          ) : (
                            <button
                              onClick={() => {
                                setSelectedPlan("BUSINESS");
                                setPhoneCheckout(true);
                              }}
                              className=" w-full  rounded-md bg-ula-primary px-2  py-3 text-sm text-white lg:w-full lg:px-5"
                            >
                              Upgrade now
                            </button>
                          )}
                        </div>
                      </div>
                    </form>
                  ) : null}
                  {phoneCheckout ? (
                    <ModalPhone
                      selectedPlan={selectedPlan}
                      listerData={listerData}
                      setOpen={setOpen}
                      fireConfetti={fireConfetti}
                      verifyTrans={verifyTrans}
                    />
                  ) : null}
                </motion.div>
              </Dialog.Content>

              <Toast.Provider swipeDirection="right">
                <Toast.Root
                  duration={2800}
                  className=" flex w-[85vw] flex-row justify-between space-x-0 rounded-lg border border-red-100  bg-red-100 px-6 py-4 shadow-lg lg:w-auto"
                  open={openToast}
                  onOpenChange={() => {
                    setOpenToast(false);
                    setError(null);
                  }}
                >
                  <AnimatePresence>
                    {open && (
                      <motion.div
                        initial={{ opacity: 0, y: 20, scale: 0.7 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{
                          opacity: 0,
                          scale: 0.5,
                          transition: { duration: 0.6 },
                        }}
                        className="flex flex-row"
                      >
                        <div className=" flex flex-col space-y-0">
                          <Toast.Title className="  mb-0 text-base font-semibold text-red-600 ">
                            {authError(error?.errorCode).title}
                          </Toast.Title>
                          <Toast.Description asChild>
                            <span className=" text-sm text-red-600">
                              {authError(error?.errorCode).message}
                            </span>
                          </Toast.Description>
                        </div>
                        <Toast.Action altText="Close">
                          <span
                            onClick={() => {
                              setOpenToast(false);
                            }}
                            className=" invisible ml-8 rounded-md border  border-red-200 bg-transparent px-4 py-1 text-xs font-semibold text-black "
                          >
                            Close
                          </span>
                        </Toast.Action>
                        <Toast.Close />
                      </motion.div>
                    )}
                  </AnimatePresence>
                </Toast.Root>

                <Toast.Viewport className=" fixed bottom-0 right-0 m-0 mb-5 mr-10 flex max-w-screen-lg flex-col gap-10" />
              </Toast.Provider>
            </Dialog.Portal>
          ) : null}
        </AnimatePresence>
      </Dialog.Root>
    </>
  );
}

export default UpgradeModal;
